<template>
    <div class="container">
        <div class="allbox">
            <div class="tab">
                <div class="tab_button">
                    <div class="tab-item" v-for="(item,index) in tabList" :key="index"
                         :class="{active:currentClass==index}" @click="toggleTab(index)">
                        <span class="tabitem">{{item}}</span>
                    </div>
                </div>
            </div>
            <div class="tab_con" v-show="currentTab==0">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad">
                    <div class="tabbox" v-for="(item,index) in dataList" :key="index"
                         @click="goDetail(item.status,item.afterSaleNo)">
                        <div class="dior">
                            <span class="store">{{ item.merchantName }}</span>
                            <!-- status 售后状态 分为只退款  退款退货两大部分 -->
							<span class="examine" v-if=" item.status == '1010' ">处理中</span>
							<span class="examine" v-else-if=" item.status == '1030' ">审核通过</span>
							<span class="examine" v-else-if=" item.status == '1040' ">审核拒绝</span>
							<span class="examine" v-else-if=" item.status == '1070' ">退款成功</span>
                        </div>
                        <div class="commodity-img">
                            <div class="comimg">
                                <img :src="item.goodsImgUrl" alt="" width="100%">
                            </div>
                            <div class="commodity-content">
                                <div class="titlecount">
                                    <span class="title">{{ item.goodsName }}</span>
                                    <span class="count">x{{ item.goodsNum }}</span>
                                </div>
                                <span class="text">退款：¥{{ item.returnRealAmount }}</span>
                            </div>
                        </div>
                    </div>
                </van-list>
            </div>
            <div class="tab_con" v-show="currentTab==1">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad">
                    <div class="tabbox" v-for="(item,index) in dataList" :key="index" @click="goDetail(item.status)">
                        <div class="dior">
                            <span class="store">{{ item.merchantName }}</span>
                            <!-- status 售后状态 分为只退款  退款退货两大部分 -->
							<span class="examine" v-if=" item.status == '1010' ">处理中</span>
							<span class="examine" v-else-if=" item.status == '1030' ">审核通过</span>
							<span class="examine" v-else-if=" item.status == '1040' ">审核拒绝</span>
							<span class="examine" v-else-if=" item.status == '1070' ">退款成功</span>
                        </div>
                        <div class="commodity-img">
                            <div class="comimg">
                                <img :src="item.goodsImgUrl" alt="" width="100%">
                            </div>
                            <div class="commodity-content">
                                <div class="titlecount">
                                    <span class="title">{{ item.goodsName }}</span>
                                    <span class="count">x{{ item.goodsNum }}</span>
                                </div>
                                <span class="text">退款：¥{{ item.returnRealAmount }}</span>
                            </div>
                        </div>
                    </div>
                </van-list>
            </div>
            <div class="tab_con" v-show="currentTab==2">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad">
                    <div class="tabbox" v-for="(item,index) in dataList" :key="index" @click="goDetail(item.status)">
                        <div class="dior">
                            <span class="store">{{ item.merchantName }}</span>
                            <!-- status 售后状态 分为只退款  退款退货两大部分 -->
							<span class="examine" v-if=" item.status == '1010' ">处理中</span>
							<span class="examine" v-else-if=" item.status == '1030' ">审核通过</span>
							<span class="examine" v-else-if=" item.status == '1040' ">审核拒绝</span>
							<span class="examine" v-else-if=" item.status == '1070' ">退款成功</span>
                        </div>
                        <div class="commodity-img">
                            <div class="comimg">
                                <img :src="item.goodsImgUrl" alt="" width="100%">
                            </div>
                            <div class="commodity-content">
                                <div class="titlecount">
                                    <span class="title">{{ item.goodsName }}</span>
                                    <span class="count">x{{ item.goodsNum }}</span>
                                </div>
                                <span class="text">退款：¥{{ item.returnRealAmount }}</span>
                            </div>
                        </div>
                    </div>
                </van-list>
            </div>
            <div class="tab_con" v-show="currentTab==3">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad">
                    <div class="tabbox" v-for="(item,index) in dataList" :key="index" @click="goDetail(item.status)">
                        <div class="dior">
                            <span class="store">{{ item.merchantName }}</span>
                            <!-- status 售后状态 分为只退款  退款退货两大部分 -->
                            <span class="examine" v-if=" item.status == '1010' ">处理中</span>
                            <span class="examine" v-else-if=" item.status == '1030' ">审核通过</span>
                            <span class="examine" v-else-if=" item.status == '1040' ">审核拒绝</span>
                            <span class="examine" v-else-if=" item.status == '1070' ">退款成功</span>
                        </div>
                        <div class="commodity-img">
                            <div class="comimg">
                                <img :src="item.goodsImgUrl" alt="" width="100%">
                            </div>
                            <div class="commodity-content">
                                <div class="titlecount">
                                    <span class="title">{{ item.goodsName }}</span>
                                    <span class="count">x{{ item.goodsNum }}</span>
                                </div>
                                <span class="text">退款：¥{{ item.returnRealAmount }}</span>
                            </div>
                        </div>
                    </div>
                </van-list>
            </div>
        </div>

    </div>

</template>
<script>
    import {afterList} from "@/api/api";

    export default {
        name: 'Home',
        props: {},
        data() {
            return {
                value: '',
                currentTab: 0,
                currentClass: 0,
                tabList: ['全部', '处理中', '审核通过','退款成功'],
                isRequestFinished: false,  // 请求是否结束
                start: 1,
                limit: 10,
                loading: false,            // 是否加载中
                finished: false,           // 是否加载完成
                dataList: [],               // 售后列表数据
            };
        },
        methods: {
            toggleTab(current) {
                this.start=1
                this.currentTab = current;
                this.currentClass = current;
                this.dataList =[]
                this.getList();
            },
            goDetail(current, afterSaleNo) {
                if (current == '1030') {
                    this.$router.push({
                        path: "/orders/Refundsuccessful?afterSaleNo=" + afterSaleNo
                    });
                } else if (current == '1010') {
                    this.$router.push({
                        path: "/orders/Underreview?afterSaleNo=" + afterSaleNo
                    });
                } else {
                    this.$router.push({
                        path: "/orders/Aftersale?afterSaleNo=" + afterSaleNo
                    });
                }
            },
            // 获取售后列表数据啊
            async getList() {
				let status= undefined
                if (this.currentTab == 1) {
					status='1010'
                }else if(this.currentTab == 2){
					status='1030'
				}else if(this.currentTab == 3){
					status='1070'
				}
                const params = {
                    start: this.start,
                    limit: this.limit,
                    status: status
                }
                const res = await afterList(params)
                if (res.code === '0000') {
                    if(res.data.rows.length >0){
                        this.dataList = this.dataList.concat(res.data.rows)
                    }else{
                        this.dataList =[]
                    }
                    this.isRequestFinished = true;
                    if (res.data.rows.length < this.limit) {
                        this.finished = true;
                    }
                    this.start += 1;
                    this.loading = false;
                } else {
                    this.$toast(res.msg)
                }

            },
        },
        created() {
            // 请求售后列表
            this.getList();
        },
    }
</script>
<style scoped lang="scss">
    .container {
        .allbox {
            .tab {
                background: #fff;
                padding-bottom: 10px;
                margin-bottom: 10px;

                .tab_button {
                    display: flex;

                    .tab-item {
                        text-align: center;
                        flex: 1;

                        .tabitem {
                            font-size: 28px;
                            font-weight: 500;
                            color: #666666;
                            line-height: 40px;
                        }
                    }
                }

                .tab-item.active {
                    .tabitem {
                        border-bottom: 4px solid #1E53A4;
                        padding-bottom: 10px;
                        color: #1E53A4;
                    }

                }
            }

            .tab_con {
                .tabbox {
                    background-color: #fff;
                    padding: 10px 20px;
                    margin-bottom: 20px;

                    .dior {
                        display: flex;
                        justify-content: space-between;
                        padding-bottom: 17px;
                        border-bottom: 1px solid #999999;

                        span {
                            display: block;
                        }

                        .store {
                            font-size: 26px;
                            font-weight: 500;
                            color: #999999;
                            line-height: 37px;
                        }

                        .examine {
                            font-size: 28px;
                            font-family: PingFangSC, PingFangSC-Regular;
                            font-weight: 400;
                            color: $theme-color-main;
                            line-height: 40px;
                        }
                    }

                    .commodity-img {
                        display: flex;
                        padding-top: 14px;

                        span {
                            display: block;
                        }

                        .commodity-content {
                            flex: 2;
                            padding-left: 20px;

                            .titlecount {
                                display: flex;
                                justify-content: space-between;
                                padding-bottom: 80px;

                                .title {
									width: 450px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
                                    font-size: 28px;
                                    font-weight: 500;
                                    color: #333333;
                                    line-height: 40px;
                                    font-family: PingFangSC, PingFangSC-Medium;
                                }

                                .count {
                                    font-size: 28px;
                                    font-family: PingFangSC, PingFangSC-Medium;
                                    font-weight: 500;
                                    color: #1e53a4;
                                    line-height: 40px;
                                }
                            }

                            .text {
                                font-size: 28px;
                                font-family: PingFangSC, PingFangSC-Medium;
                                font-weight: 500;
                                color: #999999;
                                line-height: 40px;
                            }
                        }

                        .comimg {
                            width: 180px;
                            height: 180px;

                            img {
                                border-radius: 8px;
                            }

                        }
                    }
                }

            }

        }
    }
</style>
